import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { fetchCurrentWeather, fetchHourlyWeather } from '../utils/api';
import { Weather, HourlyWeather } from '../types/weather';

interface WeatherState {
  [cityId: string]: {
    loading: boolean;
    error: string | null;
    weather: Weather | null;
    hourly: HourlyWeather[];
  };
}

const initialState: WeatherState = {};

export const getWeather = createAsyncThunk(
  'weather/getWeather',
  async (city: { id: string; name: string }) => {
    const data = await fetchCurrentWeather(city.name);
    return { cityId: city.id, weather: {
      temp: data.main.temp,
      description: data.weather[0].description,
      icon: data.weather[0].icon,
      humidity: data.main.humidity,
      wind: data.wind.speed,
      dt: data.dt,
    }};
  }
);

export const getHourlyWeather = createAsyncThunk(
  'weather/getHourlyWeather',
  async ({ cityId, lat, lon }: { cityId: string; lat: number; lon: number }) => {
    const data = await fetchHourlyWeather(lat, lon);
    return { cityId, hourly: data.hourly };
  }
);

const weatherSlice = createSlice({
  name: 'weather',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getWeather.pending, (state, action) => {
        const cityId = action.meta.arg.id;
        state[cityId] = { ...state[cityId], loading: true, error: null };
      })
      .addCase(getWeather.fulfilled, (state, action) => {
        const { cityId, weather } = action.payload;
        state[cityId] = { ...state[cityId], loading: false, weather, error: null };
      })
      .addCase(getWeather.rejected, (state, action) => {
        const cityId = action.meta.arg.id;
        state[cityId] = { ...state[cityId], loading: false, error: action.error.message || 'Error' };
      })
      .addCase(getHourlyWeather.fulfilled, (state, action) => {
        const { cityId, hourly } = action.payload;
        state[cityId] = { ...state[cityId], hourly };
      });
  },
});

export default weatherSlice.reducer; 